import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}


export default {
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`programtvpnl/detail/${obj.RecivKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2', 'progkode', 'prognama', 'blocking', 'groupprog', 'newscateg', 'newsdep', 'spotrate', 'liveprod', 'stdcostkey'];
        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/programtvpnl/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'procure_order_list.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });

    },
    insert(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("/programtvpnl", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    upload(fileXlsx, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', fileXlsx, fileXlsx.name);
                // const keys = ['sheetName', 'startRow', 'invoiceno', 'CustCode', 'CustName', 'Address1', 'npwp','npwp_name'];
                for (const key in obj) {

                    // if (keys.indexOf(key) >= 0 && obj[key]) {
                    fd.append(key, obj[key]);
                    // }
                }

                const resp = await axios.post("programtvpnl/upload", fd);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2', 'progkode', 'prognama', 'blocking', 'groupprog', 'newscateg', 'newsdep', 'spotrate', 'liveprod', 'stdcostkey'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/programtvpnl${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.pohdrkey);
                url = `/procure/print`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`procure/${obj.pohdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }

};